module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_7005.714f9e7a.png";